import { memo, FC } from 'react'
import { useColorMode, IconButton, ButtonProps } from '@chakra-ui/react'
import { Moon, Sun } from 'components/icons'

type Props = ButtonProps & {
  iconColor?: string
}

const ThemeToggleButton: FC<Props> = ({ iconColor = 'dark', variant = 'ghost', ...rest }) => {
  const { colorMode, toggleColorMode } = useColorMode()

  return (
    <IconButton
      aria-label="Botão para alternar o tema"
      variant={variant}
      onClick={toggleColorMode}
      colorScheme="gray"
      icon={colorMode === 'light' ? <Moon variant="filled" color={iconColor} /> : <Sun variant="filled" color={iconColor} />}
      {...rest}
    />
  )
}

export default memo(ThemeToggleButton)
